//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import poshDetailTable from './components/poshDetailTable'
import { searchTransactionBar } from '../components'
import { exportExcel } from '@/utils/excel'
export default {
  name: 'PoshTransRecordPage',
  extends: vComponent,
  components: { poshDetailTable, searchTransactionBar },
  data () {
    return {
      items: [], // 會員點數紀錄
      columns: [ // 欄位宣告
        { name: 'T_DAY',
          required: true,
          label: '交易日期',
          field: 'T_DAY',
          format: (val, row) => moment(val, 'YYYYMMDD').format('YYYY/MM/DD')
        },
        { name: 'T_TIME',
          label: '交易時間',
          field: 'T_TIME',
          format: (val, row) => moment(val, 'hhmm').format('HH:mm')
        },
        { name: 'STORE_NAME',
          // required: true,
          label: '交易門市',
          // field: 'STORE_NAME'
          field: 'STR_NAME'
        },
        { name: 'T_SER_NO',
          label: '交易序號',
          field: 'T_SER_NO'
        },
        { name: 'AMOUNT',
          label: '交易金額',
          field: 'AMOUNT'
        }
      ],
      visibleColumns: ['T_DAY', 'T_TIME', 'STORE_NAME', 'T_SER_NO', 'AMOUNT'],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 10, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      meta: {},
      expandIndex: null, // 目前展開的row rowIndex
      searchBarId: 'trans_record_search',
      queryOpt: null // 查詢參數
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'stock_no',
      'theme'
    ])
  },
  async created () {
    if (this.$q.screen.lt.sm) {
      this.visibleColumns = ['T_SER_NO', 'AMOUNT']
    }
    await this.doQuery()
  },
  mounted () {
    this.addHandler()
  },
  methods: {
    addHandler () {
      this.on('TransRecord.Query', async () => {
        await this.doQuery()
      })
      this.on('SearchTransactionBar.Search', async (searchBarId, searchObj) => {
        if (searchBarId === this.searchBarId) {
          console.log(`searc obj searchBarId =${searchBarId}`)
          console.log(searchObj)
          this.queryOpt = searchObj
          await this.doQuery()
        }
      })
      this.on('SearchTransactionBar.Export', async (searchBarId, searchObj) => {
        if (searchBarId === this.searchBarId) {
          console.log(`searc obj searchBarId =${searchBarId}`)
          console.log(searchObj)
          this.queryOpt = searchObj
          await this.doExport()
        }
      })
    },
    async doQuery () {
      const data = { SITE: this.site, VIP_CODE: this.params.vip_code }
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      // 加入查詢參數
      if (this.queryOpt !== null) {
        // stock_no null預設查登入者stock_no, ''代表查全部stock_no
        if (this.queryOpt.STOCK_NO === null) {
          data.STOCK_NO = this.stock_no
        } else if (this.queryOpt.STOCK_NO !== '') {
          data.STOCK_NO = this.queryOpt.STOCK_NO
        }
        if (this.queryOpt.sDate !== null) data.sDate = moment(this.queryOpt.sDate, 'YYYY/MM/DD').format('YYYYMMDD')
        if (this.queryOpt.eDate !== null) data.eDate = moment(this.queryOpt.eDate, 'YYYY/MM/DD').format('YYYYMMDD')
      }
      console.log(`query obj===`)
      console.log(data)
      console.log(`site=${this.site} stock_no=${this.stock_no} params.id_no=${this.params.id_no}`)
      const response = await this.fetch('transaction_posh', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
      console.log(response)
    },
    async doQueryDetail (row) {
      const data = {
        SITE: row.SITE,
        T_STORE: row.T_STORE,
        T_DAY: row.T_DAY,
        TM_NO: row.TM_NO,
        T_SER_NO: row.T_SER_NO
      }
      const response = await this.fetch('transaction_posi', data)
      const items = response.data !== null ? response.data.items : []
      return items
    },
    async onRequest (props) {
      const { page, rowsPerPage } = props.pagination
      // const filter = props.filter
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      console.log('on request props=')
      console.log(props)
      await this.doQuery()
    },
    async clickExpand (rowIndex, props) {
      console.log(`rowIndex=${rowIndex} this.expandIndex=${this.expandIndex}`)
      if (rowIndex === null) return
      console.log(`click rowIndex==${rowIndex} pageIndex=${props.pageIndex}`)
      if (rowIndex === this.expandIndex) {
        this.expandIndex = null
        console.log('close')
      } else {
        console.log(this.items)
        this.expandIndex = rowIndex
        let index = props.pageIndex
        console.log(`open rowIndex=${rowIndex} page index=${props.pageIndex}`)
        if (this.items[index] && this.items[index].items.length === 0) {
          console.log('load detail')
          const items = await this.doQueryDetail(props.row)
          console.log('detail items==')
          console.log(items)
          this.items[index].items = items
        }
      }
    },
    getKey (prefix, row, rowIndex) {
      return `${prefix}_${row.T_DAY}_${row.T_TIME}_${row.T_SER_NO}_${rowIndex}`
    },
    // 輸出 先取得全部資料
    async doExport () {
      let items = await this.getExportRows()
      items = this.converRows(items)
      this.exportExcel(items)
    },
    // --取得要輸出的全部資料
    async getExportRows () {
      const data = { SITE: this.site, VIP_CODE: this.params.vip_code }
      data.countPerPage = 10000
      data.currentPage = this.pagination.page
      // 加入查詢參數
      if (this.queryOpt !== null) {
        // stock_no null預設查登入者stock_no, ''代表查全部stock_no
        if (this.queryOpt.STOCK_NO === null) {
          data.STOCK_NO = this.stock_no
        } else if (this.queryOpt.STOCK_NO !== '') {
          data.STOCK_NO = this.queryOpt.STOCK_NO
        }
        if (this.queryOpt.sDate !== null) data.sDate = moment(this.queryOpt.sDate, 'YYYY/MM/DD').format('YYYYMMDD')
        if (this.queryOpt.eDate !== null) data.eDate = moment(this.queryOpt.eDate, 'YYYY/MM/DD').format('YYYYMMDD')
      }
      // console.log(`query obj===`)
      // console.log(data)
      // console.log(`site=${this.site} stock_no=${this.stock_no} params.id_no=${this.params.id_no}`)
      // 輸出還是取全部
      const response = await this.fetch('transaction', this.params.id_no, data)
      const items = response.data !== null ? response.data : []
      return items
    },
    // --轉成要輸出的rows
    converRows (rows) {
      let allItems = []
      rows.forEach(row => {
        const items = []
        let payTypeItem = null // 存放paytype
        row.items.forEach((item, index) => {
          if (item.type === 'paytype') {
            payTypeItem = item
          } else {
            // 第一筆加入row資訊
            if (index === 0) {
              item.T_VIP = this.params.vip_code
              item.STORE_NAME = row.STORE_NAME
              item.T_DAY = row.T_DAY
              item.T_TIME = row.T_TIME
              item.T_SER_NO = row.T_SER_NO
              item.T_OD = row.T_OD
              item.AMOUNT = row.AMOUNT
              // 修改顯示格式
              if (item.T_DAY) item.T_DAY = moment(item.T_DAY).format('YYYY/MM/DD')
              if (item.T_TIME) item.T_TIME = item.T_TIME.slice(0, 2) + ':' + item.T_TIME.slice(2)
            } else {
              item.T_VIP = ''
              item.STORE_NAME = ''
              item.T_DAY = ''
              item.T_TIME = ''
              item.T_SER_NO = ''
              item.T_OD = ''
              item.AMOUNT = ''
            }
            // 顯示口味加料
            if (item.detail && item.detail.length > 0) {
              const tmp = {
                TASK_NM: [],
                FEEDING_NM: [],
                VOLUME: []
              }
              item.detail.forEach(detailItem => {
                tmp[detailItem.type].push(detailItem.F_NAME)
              })
              item.TASK_NM = tmp.TASK_NM.join(',')
              item.FEEDING_NM = tmp.FEEDING_NM.join(',')
              item.VOLUME = tmp.VOLUME.join(',')
            } else {
              item.TASK_NM = ''
              item.FEEDING_NM = ''
              item.VOLUME = ''
            }
            item.paytype = ''
            items.push(item)
          }
        })
        if (payTypeItem !== null) {
          items[0].paytype = payTypeItem.PC_NAME
        }
        allItems = allItems.concat(items)
      })
      return allItems
    },
    // --
    exportExcel (items) {
      // console.log('export excel')
      // console.log(items[0])
      const gridFields = [
        { name: '會員', fieldname: 'T_VIP' },
        { name: '門市名稱', fieldname: 'STORE_NAME' },
        { name: '日期', fieldname: 'T_DAY' },
        { name: '時間', fieldname: 'T_TIME' },
        { name: '序號', fieldname: 'T_SER_NO' },
        { name: '註記', fieldname: 'T_OD' },
        { name: '商品名稱', fieldname: 'PC_NAME' },
        { name: '單價', fieldname: 'PRICE' },
        { name: '數量', fieldname: 'CNT' },
        { name: '小計', fieldname: 'TOTAL' },
        { name: '口味', fieldname: 'TASK_NM' },
        { name: '加料', fieldname: 'FEEDING_NM' },
        { name: '容量', fieldname: 'VOLUME' },
        { name: '支付別', fieldname: 'paytype' },
        { name: '總金額', fieldname: 'AMOUNT' }
      ]
      if (this.items.length > 0) {
        // 輸出excel
        exportExcel({
          gridFields,
          items: items,
          title: 'hello',
          fileName: `${items[0].T_VIP}會員交易紀錄`
        })
      } else {
        this.alert('無資料無法輸出!!')
      }
    }
  }
}
